import { faqData } from '@/mocks/homeData';

export default function SectionFaq() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            答疑解惑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">关于黑料吃瓜网，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 md:px-6 md:py-5 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-8">
                  {item.question}
                </h3>
                <i className="ri-add-line text-lg text-foreground-400 group-open:hidden flex-shrink-0"></i>
                <i className="ri-subtract-line text-lg text-primary-500 hidden group-open:block flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-5 md:px-6 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}